import type { FC } from "react";

import { CloseCircleOutlined } from "@ant-design/icons";
import { Divider } from "antd";

type Props = {
  children?: React.ReactNode;
  closeAction?: () => void;
  hasDivider?: boolean;
};
export const ModalHeader: FC<Props> = ({
  children,
  closeAction,
  hasDivider = true,
}) => {
  return (
    <>
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-normal text-raven-700">{children}</h2>

        {closeAction && (
          <button
            className="cursor-pointer border-none bg-transparent"
            onClick={() => closeAction()}
          >
            <CloseCircleOutlined className="text-xl text-aubergine-perl-500" />
          </button>
        )}
      </div>
      {hasDivider && <Divider />}
    </>
  );
};
